import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../http.service";
import {environment} from "../../environments/environment";
import {Http, Response, Headers, RequestOptions} from "@angular/http";
import {Yearweek} from "../models/yearweek";
import {MenuService} from "./service/menu.service";

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    providers: [MenuService]
})
export class MenuComponent implements OnInit
{
    private router: Router;
    private http: Http;
    private MenuService: MenuService;
    public yearWeek: number;
    public productionEnabled: boolean;

    constructor(router: Router, http: Http, MenuService: MenuService)
    {
        this.router = router;
        this.http   = http;
        this.MenuService = MenuService;
        this.productionEnabled = environment.production;
    }

    public showHandleiding()
    {
        window.open(environment.base_url + 'handleiding', '_blank');
    }

    public goToTileGroup(Id)
    {
        location.href = environment.base_url + '#' + Id;
    }

    ngOnInit() {
        this.MenuService.getYearweek().then( data => this.yearWeek = data.yearweek);
    }
}


// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts